import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as assets from './assets.js';

export default {
  getTextColorByBackgroundColor(backgroundColor){
    if (!backgroundColor) return 'black';
    const r = parseInt(backgroundColor.substr(1, 2), 16);
    const g = parseInt(backgroundColor.substr(3, 2), 16);
    const b = parseInt(backgroundColor.substr(5, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
  },


  parseCRMWhatsappContactNameToDisplay(CRMWhatsappContactInformation) {
    if (CRMWhatsappContactInformation.CRMWhatsappContactID) {
      return [
        CRMWhatsappContactInformation.CRMWhatsappContactFirstName,
        CRMWhatsappContactInformation.CRMWhatsappContactMiddleName,
        CRMWhatsappContactInformation.CRMWhatsappContactFirstSurname,
        CRMWhatsappContactInformation.CRMWhatsappContactSecondSurname
      ].filter(Boolean).join(' ');
    }
    return 'No registrado';
  },

  parseAmountToDisplay(amount){
    return `${parseFloat(amount).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
  },

  parseAmountToDisplayWithoutDecimals(amount){
    return `${parseFloat(amount).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})}`;
  },

  fromHourToHHMM(hour){
    try {
      if (hour){
        return `${hour > 12 ? hour - 12 : hour}:00 ${hour > 12 ? 'PM' : 'AM'}`;
      } else {
        return 'No registrado';
      }
    } catch {
      return 'Error';
    }
  },

  fromSecondsToDaysHHMMSS(seconds) {
    const years = Math.floor(seconds / (365 * 24 * 3600));
    seconds %= (365 * 24 * 3600);
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= (24 * 3600);
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    if (years > 0) return `${years > 0 ? `${years} año${years > 1 ? 's' : ''}` : ''}${years > 0 && days > 0 ? ', ' : ''}${days > 0 ? `${days} día${days > 1 ? 's' : ''}, ` : years > 0 ? ', ' : ''}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    if (days > 0) return `${days} día${days > 1 ? 's' : ''}${hours > 0 || minutes > 0 || remainingSeconds > 0 ? `, ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}` : ''}`;
    if (hours > 0) return `${hours} hora${hours > 1 ? 's' : ''}${minutes > 0 || remainingSeconds > 0 ? `, ${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}` : ''}`;
    if (minutes > 0) return `${minutes} minuto${minutes > 1 ? 's' : ''}${remainingSeconds > 0 ? ` y ${remainingSeconds} segundo${remainingSeconds != 1 ? 's' : ''}` : ''}`;
    return `${remainingSeconds} segundo${remainingSeconds != 1 ? 's' : ''}`;
  },


  fromDatetimeToHHMMSSDDMMYYYY(datetime) {
    try {
      if (datetime){
        const date = new Date(datetime);
        const pad = (n) => n.toString().padStart(2, '0');
        const hours = pad(date.getHours()) > 12 ? pad(date.getHours() - 12) : pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        return `${hours}:${minutes}:${seconds} ${date.getHours() > 12 ? 'PM' : 'AM'}, ${day}-${month}-${year}`;
      } else {
        return 'No registrado'
      }
    } catch {
      return 'Error'
    }
  },

  fromDatetimeToHHMMSS(datetime) {
    try {
      if (datetime){
        const date = new Date(datetime);
        const pad = (n) => n.toString().padStart(2, '0');
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${hours}:${minutes}:${seconds}`;
      } else {
        return 'No registrado'
      }
    } catch {
      return 'Error'
    }
  },

  fromDatetimeToDDMMYYYY(datetime) {
    try {
      if (datetime){
        const date = new Date(datetime);
        const pad = (n) => n.toString().padStart(2, '0');
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      } else {
        return 'No registrado'
      }
    } catch {
      return 'Error'
    }
  },

  fromDatetimeToHHMM(datetime) {
    try {
      if (datetime){
        const date = new Date(datetime);
        const pad = (n) => n.toString().padStart(2, '0');
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        return `${hours}:${minutes}`;
      } else {
        return 'No registrado'
      }
    } catch {
      return 'Error'
    }
  },

  getDatetimeOffsetToDayHHMMSS(originDatetime, limitDatetimeDayOffset, limitDatetimeHourOffset, limitDatetimeMinuteOffset, limitDatetimeSecondOffset){
    const limitDatetime = new Date();
    limitDatetime.setDate(limitDatetime.getDate() + (limitDatetimeDayOffset || 0));
    limitDatetime.setHours(limitDatetime.getHours() + (limitDatetimeHourOffset || 0));
    limitDatetime.setMinutes(limitDatetime.getMinutes() + (limitDatetimeMinuteOffset || 0));
    limitDatetime.setSeconds(limitDatetime.getSeconds() + (limitDatetimeSecondOffset || 0));
    let datetimeOffset = Math.floor((new Date(originDatetime) - limitDatetime) / 1000);
    const datetimeOffsetIsNegative = datetimeOffset < 0;
    datetimeOffset = Math.abs(datetimeOffset);
    const dayOffset = Math.floor(datetimeOffset / (60 * 60 * 24));
    datetimeOffset %= (60 * 60 * 24);
    const hourOffset = Math.floor(datetimeOffset / (60 * 60));
    datetimeOffset %= (60 * 60);
    const minuteOffset = Math.floor(datetimeOffset / 60);
    const secondOffset = datetimeOffset % 60;
    const datetimeOffsetToDayHHMMSS = `${dayOffset > 0 ? `${dayOffset} día${dayOffset != 1 ? 's' : ''}, ` : ''}${String(hourOffset).padStart(2, '0')}:${String(minuteOffset).padStart(2, '0')}:${String(secondOffset).padStart(2, '0')}`;
    return datetimeOffsetIsNegative ? `Hace ${datetimeOffsetToDayHHMMSS}` : `En ${datetimeOffsetToDayHHMMSS}`;
  },

  fromSecondsToMMSS(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const pad = (n) => n.toString().padStart(2, '0'); 
    return `${minutes > 0 ? minutes : 0}:${pad(remainingSeconds)}`;
  },

  fromMilisecondsToHHMMSS(miliseconds){
    const seconds = Math.floor(miliseconds / 1000);
    return this.fromSecondsToHHMMSS(seconds);
  },

  fromSecondsToHHMMSS(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const pad = (n) => n.toString().padStart(2, '0');
    return `${hours > 0 ? hours : 0}:${pad(minutes)}:${pad(remainingSeconds)}`;
  },

  fromSecondsToHoursMinutes(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    
    if (hours > 0) {
      return `${hours} hora${hours != 1 ? 's' : ''}, ${minutes} minuto${minutes != 1 ? 's' : ''}`;
    } else {
      return `${minutes} minuto${minutes != 1 ? 's' : ''}`;
    }
  },

  fromMilisecondsToYearsMonthsDaysHoursMinutesSeconds(miliseconds){
    const years = Math.floor(miliseconds / (1000 * 60 * 60 * 24 * 365));
    const months = Math.floor((miliseconds % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
    const days = Math.floor((miliseconds % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((miliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((miliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((miliseconds % (1000 * 60)) / 1000);
    const parts = [];
    if (years > 0) parts.push(`${years} año${years != 1 ? 's' : ''}`);
    if (months > 0) parts.push(`${months} mes${months != 1 ? 'es' : ''}`);
    if (days > 0) parts.push(`${days} día${days != 1 ? 's' : ''}`);
    if (hours > 0) parts.push(`${hours} hora${hours != 1 ? 's' : ''}`);
    if (minutes > 0) parts.push(`${minutes} minuto${minutes != 1 ? 's' : ''}`);
    if (seconds > 0) parts.push(`${seconds} segundo${seconds != 1 ? 's' : ''}`);
    return parts.length > 0 ? parts.join(', ') : '0 segundos';
  },

  getDatetimeDifferenceToHHMMSS(startDatetime, endDatetime){
    const pad = (n) => n.toString().padStart(2, '0');
    return `${pad(Math.floor((new Date(endDatetime) - new Date(startDatetime)) / (1000 * 60 * 60)))}:${pad(Math.floor(((new Date(endDatetime) - new Date(startDatetime)) % (1000 * 60 * 60)) / (1000 * 60)))}:${pad(Math.floor(((new Date(endDatetime) - new Date(startDatetime)) % (1000 * 60)) / 1000))}`;
  },

  fromPhoneNumberToCountryCodePhoneNumberCountryFlag(phoneNumber, showCountryFlag = true){
    const parsedPhoneNumber = parsePhoneNumberFromString(`+${phoneNumber}`);
    return parsedPhoneNumber ? `(${parsedPhoneNumber.countryCallingCode}) ${parsedPhoneNumber.nationalNumber} ${showCountryFlag ? assets.default.countryFlagEmojiByCountryAcronim[parsedPhoneNumber.country] || '' : ''}` : phoneNumber;
  },

  fromMetersToKilometers(meters) {
    return (meters / 1000).toFixed(2) + ' km';
  }

}